export const PIXEL_ID = '2243850073137099'

const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

type FbqArgs = unknown[]

interface FbqFunction {
  (...args: FbqArgs): void
  callMethod?: (...args: FbqArgs) => void
  queue: FbqArgs[]
  push: FbqFunction
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

let initialized = false
let scriptRequested = false

/**
 * Installs the standard fbq stub so events can be queued before
 * fbevents.js finishes downloading (nothing is ever lost).
 */
function installStub(): FbqFunction | null {
  if (typeof window === 'undefined') return null
  if (window.fbq) return window.fbq

  const fbq = function (...args: FbqArgs) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue.push(args)
    }
  } as FbqFunction

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  return fbq
}

/** Downloads fbevents.js (async). Safe to call many times. */
export function loadPixelScript(): void {
  if (typeof document === 'undefined' || scriptRequested) return
  scriptRequested = true
  installStub()
  const script = document.createElement('script')
  script.async = true
  script.src = SCRIPT_SRC
  document.head.appendChild(script)
}

/** Queues init + PageView. Fires as soon as the script is available. */
export function initPixel(): void {
  if (initialized) return
  const fbq = installStub()
  if (!fbq) return
  initialized = true
  fbq('init', PIXEL_ID)
  fbq('track', 'PageView')
}

/** Event id shared with the Conversions API so events de-duplicate. */
export function newEventId(prefix: string): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

export function trackAddToCart(
  payload: Record<string, unknown>,
  eventId: string
): void {
  const fbq = installStub()
  if (!fbq) return
  // Make sure the real script is in flight even if the delayed load hasn't run.
  loadPixelScript()
  fbq('track', 'AddToCart', payload, { eventID: eventId })
}
